import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { setBreadcrumb } from 'components/Navbar/modules';
import { goHome } from 'modules/steps/actions';
import CancelDeletionAccount from '../components/CancelDeletionAccount';

function mapStateToProps(state) {
  return {
    literals: state.i18n.literals.cancelDeletionAccount,
    color: state.app.color1,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    setBreadcrumb: bindActionCreators(setBreadcrumb, dispatch),
    goHome: bindActionCreators(goHome, dispatch),
  };
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(CancelDeletionAccount),
);



// WEBPACK FOOTER //
// ./src/routes/CancelDeletionAccount/container/index.js